import { render, staticRenderFns } from "./StockOBV.vue?vue&type=template&id=7569371f&scoped=true"
import script from "./StockOBV.vue?vue&type=script&lang=js"
export * from "./StockOBV.vue?vue&type=script&lang=js"
import style0 from "./StockOBV.vue?vue&type=style&index=0&id=7569371f&prod&scoped=true&lang=css"
import style1 from "./StockOBV.vue?vue&type=style&index=1&id=7569371f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569371f",
  null
  
)

export default component.exports